import forms from './demodata/reactformtemplate';
import DemoViewProvider from './demoviews/demoviewprovider';
import * as DefaultViewsMod from './defaultviews';

export * from './reactform';
export * from './reactformfield';
export * from './reactformfieldlist';
export * from './reactformgroupwrapper';
export * from './reactformfieldemailinput';
export * from './reactformfielddatecombos';
export * from './util';

export const DefaultViews = DefaultViewsMod;

// This demo is included in the module so external projets can use them
// in their dev environment.
export const demo = {
    viewProvider: DemoViewProvider,
    forms: forms,
    template1: forms // Legacy, get rid of that when changed in other projects
};
